import "moment/locale/pt-br";
import "react-datetime/css/react-datetime.css";
import React, { useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Flex,
    Input,
    useColorModeValue,
    useDisclosure,
} from "@chakra-ui/react";
import { FilterContainer } from "components/Tables/FilterContainer";
import DateTime from "react-datetime";
import { LOCALE_PT_BR } from "constants/date-time";

export const ManagerialFilter = (props) => {
    const { t } = useTranslation('common');
    const { onFilter } = props;
    const { isOpen, onToggle } = useDisclosure();
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());
    const placeholderColor = useColorModeValue("gray.300", "gray.400");

    const isStartDateInvalid = startDate ? startDate > new Date() : false;
    const isEndDateInvalid = startDate && endDate ? endDate < startDate : false;
    const isValidDate = (date) => moment(date, moment.ISO_8601, true).isValid();
    const isFilterDisabled = !isValidDate(startDate) || !isValidDate(endDate) || isStartDateInvalid || isEndDateInvalid;

    const onFilterHandler = () => {
        onFilter({
            data_inicial: startDate ? new Date(startDate).toLocaleDateString(LOCALE_PT_BR) : "",
            data_final: endDate ? new Date(endDate).toLocaleDateString(LOCALE_PT_BR) : "",
        });
    }

    const onClearHandler = () => {
        setStartDate(moment());
        setEndDate(moment());
    };

    return (
        <FilterContainer
            w='125px'
            fontSize='sm'
            fontWeight='bold'
            variant="light"
            isOpen={isOpen}
            onToggle={onToggle}
            onFilter={onFilterHandler}
            onClear={onClearHandler}
            isFilterDisabled={isFilterDisabled}
        >
            <Flex w="100%" gap="4" justify="space-between">
                <FormControl w="230px" isInvalid={isStartDateInvalid}>
                    <FormLabel>
                        {t("system.labels.start-date")}
                    </FormLabel>
                    <DateTime
                        locale={LOCALE_PT_BR}
                        closeOnSelect
                        timeFormat={false}
                        value={startDate || ""}
                        inputProps={!startDate ? { placeholder: t("system.placeholders.date") } : {}}
                        renderInput={(props) => (
                            <Input
                                {...props}
                                fontSize="sm"
                                _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                            />
                        )}
                        onChange={date => setStartDate(date)} />
                    <FormErrorMessage>
                        {t("system.messages.errors.invalid-start-date")}
                    </FormErrorMessage>
                </FormControl>

                <FormControl w="230px" isInvalid={isEndDateInvalid}>
                    <FormLabel>
                        {t("system.labels.end-date")}
                    </FormLabel>
                    <DateTime
                        locale={LOCALE_PT_BR}
                        closeOnSelect
                        timeFormat={false}
                        value={endDate || ""}
                        inputProps={!endDate ? { placeholder: t("system.placeholders.date") } : {}}
                        renderInput={(props) => (
                            <Input
                                {...props}
                                fontSize="sm"
                                _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                            />
                        )}
                        onChange={date => setEndDate(date)} />
                    <FormErrorMessage>
                        {t("system.messages.errors.invalid-end-date")}
                    </FormErrorMessage>
                </FormControl>
            </Flex>
        </FilterContainer>
    );
}